import { render, staticRenderFns } from "./icn-close.vue?vue&type=template&id=0cfb9bb9&scoped=true&"
import script from "./icn-close.vue?vue&type=script&lang=js&"
export * from "./icn-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfb9bb9",
  null
  
)

export default component.exports